module.exports = __webpack_public_path__ + "static/media/care_device_pin.69877cf4.svg";